export default "__VITE_ASSET__CsT7ujAU__"